<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="12">
        <v-card class="pa-6 mb-16" elevation="0">
          <div class="calendar-container">
            <!-- <div class="d-flex justify-end">
              <span class="legend-item pr-4">
                <span class="legend-box company-event"></span> Company Event
              </span>
              <span class="legend-item pr-4">
                <span class="legend-box leave"></span> Leave
              </span>
              <span class="legend-item">
                <span class="legend-box holiday"></span> Holiday
              </span>
            </div> -->
            <div class="month-header">
              <v-btn @click="prevMonth" small><v-icon>mdi-chevron-left</v-icon></v-btn>

              <v-menu v-model="menuDatePicker" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <span class="month-year-picker" v-bind="attrs" v-on="on">
                    <div class="month-label">
                      <h2>{{ currentMonth }}</h2>
                    </div>
                    <div class="year-label">
                      <h1>{{ currentYear }}</h1>
                    </div>
                  </span>
                </template>

                <v-date-picker v-model="menuDateModel" type="month" @input="handleMonthPicked" color="primary"
                  scrollable></v-date-picker>
              </v-menu>

              <v-btn @click="nextMonth" small><v-icon>mdi-chevron-right</v-icon></v-btn>
            </div>


            <div class="d-flex justify-space-between align-center pb-2">

              <div class="text-subtitle-1 font-weight-medium ">
                <span class="pr-6">📅 Current Date: {{ currentFullDate }}</span>

              </div>

              <!-- ปุ่ม Today -->
              <div class="d-flex  align-center">
                <span class="legend-item pr-4">
                  <span class="legend-box company-event"></span> Company Event
                </span>
                <span class="legend-item pr-4">
                  <span class="legend-box leave"></span> Leave
                </span>
                <span class="legend-item pr-4">
                  <span class="legend-box holiday"></span> Holiday
                </span>
                <v-btn @click="goToToday" small style="text-transform: none;">
                  <h4>Today</h4>
                </v-btn>
              </div>

            </div>
            <div class="calendar-grid">
              <div class="day-header" v-for="day in daysOfWeek" :key="day">{{ day }}</div>

              <div class="calendar-cell" v-for="(day, index) in calendarGrid" :key="index"
                :class="{ today: day.date && isToday(day) }" @click="openDialog(day)">
                <div class="day-number">{{ day.date || '' }}</div>

                <div v-for="(event, i) in (day.events || [])" :key="i" v-if="i < 2" class="event" :class="event.type">
                  {{ event.title }}
                </div>

                <div v-if="day.events && day.events.length > 2" class="event"
                  style="background-color: #8ec6ff; color: white; cursor: pointer;">
                  More...
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogVisible" max-width="700">
      <v-card class="pt-3 pb-3">
        <v-card-title class="headline">
          <div style="width: 100%; text-align: center;">
            <h3 class="black--text" style="color: #868587">{{ selectedDate }}</h3>
          </div>
        </v-card-title>
        <v-card-text>
          <div v-if="selectedEvents.length === 0">No Data</div>
          <div v-else>
            <div v-if="filteredByType('holiday').length" class="mb-3 black--text">
              <!-- <h2 style="margin-bottom: 4px; color: #B6272B;">Holiday</h2>
              <ul>
                <li v-for="(event, index) in filteredByType('holiday')" :key="'h'+index">
                  {{ event.title }}
                </li>
              </ul> -->
              <h3 v-for="(event, index) in filteredByType('holiday')" :key="'p' + index">
                <v-icon color="#000000" large>mdi-calendar-text</v-icon>
                {{ event.title }} (Public Holiday)
              </h3>
            </div>
            <div v-if="filteredByType('meeting').length" class="mb-3 black--text">
              <!-- <h2 style="margin-bottom: 4px; color: #FFDE59;">Company Event</h2>
              <ul>
                <li v-for="(event, index) in filteredByType('meeting')" :key="'p'+index">
                   {{ event.title }}
                </li>
              </ul> -->
              <h3 v-for="(event, index) in filteredByType('meeting')" :key="'p' + index">
                <v-icon color="#000000" large>mdi-hospital-building</v-icon>
                {{ event.title }} (Company Event) {{ event.starttime.split(":").slice(0, -1).join(":") }} - {{
                  event.endtime.split(":").slice(0, -1).join(":") }}
              </h3>
            </div>
            <div v-if="filteredByType('person').length" class="mb-3">
              <!-- #055DAA  -->
              <h2 style="margin-bottom:20px; color: #000000;">People on Leave</h2>
              <!-- <ul>
                <li v-for="(event, index) in filteredByType('person')" :key="'p'+index">
                  {{ event.title }}
                </li>
              </ul> -->
              <v-row v-for="(event, index) in filteredByType('person')" :key="'p' + index" class="black--text">
                <v-col cols="12" sm="2" align="center">
                  <v-card style="width:50px;height:50px;border-radius:50%;">
                    <v-img style="border-radius:50%;width: 100%;height: 100%;"
                      lazy-src="https://upload.wikimedia.org/wikipedia/en/2/24/Crystal_personal.svg"
                      :src="event.show_image"></v-img>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="7" class="text-center text-md-left">
                  <h3>{{ event.title }}</h3>
                  <h3 style="color:#055DAA;">{{ event.department_name }}</h3>
                </v-col>
                <v-col cols="12" sm="3" align="center">
                  <h3>
                    <v-btn v-if="event.leave_type_name == 'Vacation Leave'" color="#0F7EA5" class="white--text" small
                      min-width="100">{{ event.leave_type_name.split(" ")[0] || "" }}</v-btn>
                    <v-btn v-else-if="event.leave_type_name == 'Sick Leave'" color="#EB903D" class="white--text" small
                      min-width="100">{{ event.leave_type_name.split(" ")[0] || "" }}</v-btn>
                    <v-btn v-else-if="event.leave_type_name == 'Business Leave'" color="#B3B3B3" class="white--text"
                      small min-width="100">{{ event.leave_type_name.split(" ")[0] || "" }}</v-btn>
                    <v-btn v-else small min-width="100">{{ event.leave_type_name.split(" ")[0] || "" }}</v-btn>
                  </h3>
                  <h4>{{ event.description }}</h4>
                </v-col>
              </v-row>
              <!-- <v-divider></v-divider> -->
            </div>

          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />
  </v-container>
</template>

<script>
import api from "@/services/api";
import { server, imageUrl } from "@/services/constants";
import StockCard from "@/components/cards/StockCard";
import SuccessDialog from "@/components/cards/SuccessDialog";
const moment = require('moment');

export default {
  name: "Calendar",
  components: {
    StockCard,
    SuccessDialog,
  },
  data() {
    return {
      menuDatePicker: false,
      menuDateModel: null,
      dialogVisible: false,
      selectedDate: '',
      selectedEvents: [],
      currentDateObj: new Date(),
      currentYear: null,
      currentMonthIndex: null, // 0 = January
      daysOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      holidaysByDate: {
        // "2025-06-01": [{ title: 'Labor Day', type: 'holiday' }],
      },
      personEventsByDate: {
        // "2025-06-04": [{ title: 'Somsak R.', type: 'person' },{ title: 'Somsak R.', type: 'person' }],
      },
      meetingEventsByDate: {
        // "2025-06-04": [
        //   { title: "Project Kickoff", type: "meeting" },
        // ],
        // "2025-06-05": [
        //   { title: "Project Kickoff2", type: "meeting" },
        // ]
      },
      dialogAdd: false,
      text_color: '',
      title: '',
      message: '',
    };
  },
  computed: {
    currentFullDate() {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, '0');
      const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      const month = monthNames[today.getMonth()];
      const year = today.getFullYear();
      return `${day} ${month} ${year}`;
    },
    currentMonth() {
      const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      return monthNames[this.currentMonthIndex];
    },
    daysInMonth() {
      return new Date(this.currentYear, this.currentMonthIndex + 1, 0).getDate();
    },
    firstDayOfMonth() {
      return new Date(this.currentYear, this.currentMonthIndex, 1).getDay();
    },
    calendarGrid() {
      const totalCells = this.daysInMonth + this.firstDayOfMonth;
      const fullWeeks = Math.ceil(totalCells / 7);
      const totalGridCells = fullWeeks * 7;

      const grid = [];

      for (let i = 0; i < totalGridCells; i++) {
        const dayNumber = i - this.firstDayOfMonth + 1;
        if (dayNumber > 0 && dayNumber <= this.daysInMonth) {
          const dateKey = `${this.currentYear}-${String(this.currentMonthIndex + 1).padStart(2, '0')}-${String(dayNumber).padStart(2, '0')}`;

          const isHoliday = this.holidaysByDate[dateKey] && this.holidaysByDate[dateKey].length > 0;

          const dayEvents = [
            ...(this.holidaysByDate[dateKey] || []),
            ...(this.meetingEventsByDate[dateKey] || []),
            // ถ้าวันนั้นเป็นวันหยุด ไม่ต้องแสดงวันลา
            ...(isHoliday ? [] : (this.personEventsByDate[dateKey] || [])),
          ];

          grid.push({
            date: dayNumber,
            events: dayEvents,
          });
        } else {
          grid.push({
            date: null,
            events: [],
          });
        }
      }
      return grid;
    }
  },
  async mounted() {
    // กำหนดค่าเริ่มต้นเป็นเดือนและปีปัจจุบัน
    this.currentYear = this.currentDateObj.getFullYear();
    this.currentMonthIndex = this.currentDateObj.getMonth();

    await api.checkVersion();

    const userId = localStorage.getItem(server.USER_ID);
    if (userId && api.isLoggedIn()) {
      // await api.checkttoken();
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
    const now = new Date();
    this.menuDateModel = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;

    await this.loadHoliday()
    await this.loadCompanyEvent()
    await this.loadLeave()

    this.$hideLoader();
  },
  methods: {
    handleMonthPicked(val) {
      const [year, month] = val.split("-").map(Number);
      this.currentYear = year;
      this.currentMonthIndex = month - 1;

      this.menuDateModel = val;
      this.menuDatePicker = false;

      this.loadHoliday();
      this.loadCompanyEvent();
      this.loadLeave();
    },
    async loadHoliday() {
      const year = this.currentYear;
      const month = String(this.currentMonthIndex + 1).padStart(2, '0'); // เพราะ currentMonthIndex เริ่มจาก 0


      var data_search = {
        month: `${year}-${month}`,
        company_id: Number(localStorage.getItem(server.COMPANYID))
      }

      var res_holiday = await api.getAllMonth({
        params: data_search
      })

      const rawData = res_holiday.data

      const holidaysByDate = {};

      rawData.forEach(item => {
        if (!holidaysByDate[item.date]) {
          holidaysByDate[item.date] = [];
        }
        holidaysByDate[item.date].push({
          ...item,
          title: item.h_name,
          type: 'holiday'
        });
      });

      this.holidaysByDate = holidaysByDate;
    },
    async loadCompanyEvent() {
      const year = this.currentYear;
      const month = String(this.currentMonthIndex + 1).padStart(2, '0');


      var data_search = {
        month: `${year}-${month}`,
        company_id: Number(localStorage.getItem(server.COMPANYID))
      }

      var res_conpany_event = await api.getAllMonthEvent({
        params: data_search
      })
      const rawData = res_conpany_event.data

      const companyEventsByDate = {};

      rawData.forEach(item => {
        if (!companyEventsByDate[item.date]) {
          companyEventsByDate[item.date] = [];
        }
        companyEventsByDate[item.date].push({
          ...item,
          title: item.event_name,
          type: 'meeting'
        });
      });

      this.meetingEventsByDate = companyEventsByDate;
    },
    async loadLeave() {
      const year = this.currentYear;
      const month = String(this.currentMonthIndex + 1).padStart(2, '0');

      var data_leave_set = {
        date_month: `${year}-${month}`,
        company_id: Number(localStorage.getItem(server.COMPANYID))
      }
      const res_leave = await api.getCalendar({ params: data_leave_set })
      // console.log("res_leave.data")
      // console.log(res_leave.data)

      var dataleave = Object.values(
        res_leave.data.reduce((acc, item) => {
          // สร้าง key โดยไม่เอา amount
          const key = `${item.userid}-${item.strc_date}-${item.leavetype}`;

          if (!acc[key]) {
            acc[key] = { ...item };
          } else {
            acc[key].amount = Number(item.amount) + Number(acc[key].amount);
          }

          return acc;
        }, {})
      );

      for (const [index, item] of dataleave.entries()) {
        var leave_day = 0;
        var leave_hours = 0;

        leave_day = Math.floor((Number(item.amount) / 60) / 8)
        leave_hours = Number(Number(item.amount) / 60) - (leave_day * 8);

        if (leave_day == 0) {
          if (leave_hours == 0) {
            item.description = ``
          } else if (leave_hours == 4) {
            item.description = item.description = `Half Day`
          } else if (leave_hours == 8) {
            item.description = item.description = `Full Day`
          } else {
            item.description = item.description = `${leave_hours} Hours`
          }
        } else {
          if (leave_hours == 0) {
            if (leave_day > 1) {
              item.description = `${leave_day} Day`
            } else {
              item.description = `Full Day`
            }
          } else {
            item.description = item.description = `${leave_day} Day ${leave_hours} Hours`
          }
        }

      }

      const rawData = dataleave;

      const leaveByDate = {};

      rawData.forEach(item => {
        const start = new Date(item.strc_date);
        const end = new Date(item.endc_date);

        // วนลูปตั้งแต่ start → end (รวม)
        for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
          const dayOfWeek = d.getDay(); // 0 = Sunday, 6 = Saturday
          if (dayOfWeek === 0 || dayOfWeek === 6) continue; // ข้ามเสาร์-อาทิตย์

          const dateStr = d.toISOString().slice(0, 10); // yyyy-mm-dd

          if (!leaveByDate[dateStr]) {
            leaveByDate[dateStr] = [];
          }

          leaveByDate[dateStr].push({
            ...item,
            show_image: `${imageUrl}/${item.image_profile}`,
            title: `${item.fullname}`,
            type: 'person'
          });
        }

      });

      this.personEventsByDate = leaveByDate;
    },
    isToday(day) {
      if (!day.date) return false;
      const today = new Date();
      return (
        day.date === today.getDate() &&
        this.currentMonthIndex === today.getMonth() &&
        this.currentYear === today.getFullYear()
      );
    },
    prevMonth() {
      if (this.currentMonthIndex === 0) {
        this.currentMonthIndex = 11;
        this.currentYear -= 1;
      } else {
        this.currentMonthIndex -= 1;
      }
      this.loadHoliday()
      this.loadCompanyEvent()
      this.loadLeave()
    },
    nextMonth() {
      if (this.currentMonthIndex === 11) {
        this.currentMonthIndex = 0;
        this.currentYear += 1;
      } else {
        this.currentMonthIndex += 1;
      }
      this.loadHoliday()
      this.loadCompanyEvent()
      this.loadLeave()
    },

    openDialog(day) {
      if (!day.date) return;
      this.selectedDate = `${moment.tz(`${this.currentYear}-${String(this.currentMonthIndex + 1).padStart(2, '0')}-${String(day.date).padStart(2, '0')}`, "Asia/Bangkok").format('ddd, DD MMMM yyyy')}`;
      // this.selectedDate = `${String(day.date).padStart(2, '0')}/${String(this.currentMonthIndex + 1).padStart(2, '0')}/${this.currentYear}`;
      this.selectedEvents = day.events || [];
      this.dialogVisible = true;
    },
    getColor(type) {
      switch (type) {
        case 'holiday':
          return '#B6272B';
        case 'person':
          return '#055DAA';
        case 'meeting':
          return '#FFDE59';
        default:
          return '#333';
      }
    },
    filteredByType(type) {
      return this.selectedEvents.filter(e => e.type === type); // แสดงทั้งหมด
    },
    goToToday() {
      const today = new Date();
      this.currentYear = today.getFullYear();
      this.currentMonthIndex = today.getMonth();
      this.loadHoliday();
      this.loadCompanyEvent();
      this.loadLeave();
    },
  },

  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
.calendar-container {
  max-width: 1000px;
  margin: auto;
  font-family: sans-serif;
}

.month-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* ซ้ายสุดและขวาสุด */
  margin-top: -10px;
}

.month-year {
  text-align: center;
  flex-grow: 1;
  /* ให้กลางกินพื้นที่ที่เหลือ */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1px;
  background-color: #ccc;
  border: 1px solid #ccc;
  cursor: pointer;
}

.day-header {
  background: #f5f5f5;
  text-align: center;
  padding: 10px 0;
  font-weight: bold;
}

.calendar-cell {
  background: white;
  min-height: 100px;
  padding: 5px;
  position: relative;
  box-shadow: none !important;
  /* ลบเงา */
}

.day-number {
  font-size: 14px;
  color: #333;
}

.event {
  margin-top: 5px;
  padding: 5px;
  border-radius: 4px;
  font-size: 12px;
  color: white;
}

.holiday {
  background-color: #B6272B;
}

.meeting {
  background-color: #FFDE59;
  color: black;
}

.person {
  background-color: #055DAA;
}

/* ไฮไลต์วันที่วันนี้ */
.today {
  background-color: #cce5ff !important;
  color: black;
}

.legend-item {
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  color: #333;
}

.legend-box {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  margin-right: 6px;
}

.legend-box.company-event {
  background-color: #FFDE59;
  /* สีม่วง */
}

.legend-box.leave {
  background-color: #055DAA;
  /* สีเหลือง */
}

.legend-box.holiday {
  background-color: #B6272B;
  /* สีแดง */
}

.month-year-picker {
  text-align: center;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 8px;
  transition: background-color 0.2s ease;

}

.month-year-picker:hover {
  background-color: #f5f5f5;
}

.month-label {
  font-size: 20px;
  font-weight: 600;
  color: #b72629;
}

.year-label {
  font-size: 16px;
  font-weight: 500;
  color: #868587;
}

.calendar-cell:hover {
  background-color: #f0f8ff;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease-in-out;
}
</style>
